import React from 'react';
import './Card.css'

const Card = ({text}) => {
  return (
    <div className='w-full subpage-banner'>
        <div className='w-full h-full subpage-overlay'>
            <div className='subpage-title'>{text}</div>
        </div>
    </div>
  )
}

export default Card